import getExternalProductId from '../../helpers/getExternalProductId'

export default ({ event, items, currency }) => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return

  const value = items.reduce((acc, { price, quantity }) => acc + price * quantity, 0)

  window.fbq('track', event, {
    value,
    currency,
    content_ids: items.map(({ variantTitle, shopifyId }) =>
      getExternalProductId(variantTitle || shopifyId)
    ),
    content_type: 'product',
  })
}
